export const jobRowClasses = Object.freeze({
  suspended: 'JobList-row--suspended',
  alerted: 'JobList-row--alerted',
  alternateGroup: 'JobList-row--alternateGroup',
});

export function getJobRowClassName(row, alertsByJob, alternateGroupRowIds) {
  return [
    row.suspend && jobRowClasses.suspended,
    alertsByJob?.[row.id]?.length > 0 && jobRowClasses.alerted,
    alternateGroupRowIds.has(row.id) && jobRowClasses.alternateGroup,
  ].filter(Boolean).join(' ');
}
